import { useEffect, useState } from 'react';
import { API } from '../api';
import DestinoCard from '../components/DestinoCard';

import './Destinos.css';

function Destinos() {
  const [destinos, setDestinos] = useState([]);

  useEffect(() => {
      window.scrollTo(0,0);
    API.get('destinos/')
      .then(res => setDestinos(res.data))
      .catch(err => console.log(err));
  }, []);

 return (
  <div className="destinos-page">

    <h1 className="destinos-title">DESTINOS</h1>

    <div className="destinos-list">
      {destinos.map(d => (
        <DestinoCard key={d.id} destino={d} />
      ))}
    </div>

    {/* RESERVAS Y PAGOS */}
    <div className="reservas-box">
      <h2>📲 Reservas y Pagos</h2>

      <p>
        Reserva tu cupo con el <strong>50% de adelanto</strong>.
        Envía tu comprobante de pago junto con tus datos completos:
      </p>

      <ul>
        <li><span>✔</span> Nombre completo</li>
        <li><span>✔</span> DNI</li>
        <li><span>✔</span> Destino</li>
        <li><span>✔</span> Punto de embarque</li>
      </ul>

      <p>
        Nuestro equipo confirmará tu reserva una vez validado el pago.
      </p>
    </div>

  </div>
);

}

export default Destinos;